import parse from 'html-react-parser';

//theme
import { homeColor } from '@/theme/ai';

//components
import {
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';

//styles
import {
  OpsGrid,
  Top100,
  Top100Big,
  Top100Small,
  Top100Copy,
  SectionCustom,
} from './FreightExperts.styles';
import { Container } from '@/components/Grid';

export function FreightExperts({ border = true, content }) {
  return (
    <SectionCustom id="operators" border={border}>
      <Container>
        <OpsGrid>
          <div>
            <Kicker color={homeColor.amber}>
              <KickerDot color={homeColor.amber} />
              {content.kicker}
            </Kicker>
            <SectionTitle>
              {content.title}
              <Grad>{content.titleHighlight}</Grad>
            </SectionTitle>
            <SectionLede>{content.lede}</SectionLede>
          </div>
          <Top100 $single={!content.badge}>
            {content.badge && (
              <div>
                <Top100Big>{content.badge.bigLabel}</Top100Big>
                <Top100Small>
                  {content.badge.smallLabelLine1}
                  <br />
                  {content.badge.smallLabelLine2}
                </Top100Small>
              </div>
            )}
            <Top100Copy>{parse(content.copy)}</Top100Copy>
          </Top100>
        </OpsGrid>
      </Container>
    </SectionCustom>
  );
}
